export enum ExtraPackageDoveIt {
  EXTRA_VISIBILITY = 'EXTRA_VISIBILITY',
  PREMIUM_VISIBILITY = 'PREMIUM_VISIBILITY',
  INTERIOR_RESTYLING = 'INTERIOR_RESTYLING',
  PRESTIGE = 'PRESTIGE',
  DRONE = 'DRONE',
  PHOTO_PLUS = 'PHOTO_PLUS',
  PERSONALIZED_MARKETING = 'PERSONALIZED_MARKETING',
  PHOTO_PRO = 'PHOTO_PRO',
  INTERIOR_DESIGN = 'INTERIOR_DESIGN',
  DRONE_VIDEO = 'DRONE_VIDEO',
  REFURBISHMENT = 'REFURBISHMENT',
  ENGLISH_VIDEO = 'ENGLISH_VIDEO',
  URBAN_PLANNING = 'URBAN_PLANNING',
  BUILDING_REGULARITY = 'BUILDING_REGULARITY',
  ENERGY_PERFORMANCE_CERTIFICATE = 'ENERGY_PERFORMANCE_CERTIFICATE',
  APE = 'APE',
  CASA_OK = 'CASA_OK',
  ALL_IN_ONE = 'ALL_IN_ONE',
}

export enum ExtraPackageSPF {
  VERIFICATION_SERVICE = 'VERIFICATION_SERVICE',
  DOCUMENTS_ACCESS = 'DOCUMENTS_ACCESS',
  SPF_APE = 'SPF_APE',
}

export type ExtraPackageType = ExtraPackageDoveIt | ExtraPackageSPF;

export enum ExtraPackageProvider {
  DOVE_IT = 'DOVE_IT',
  SPF = 'SPF',
}

export enum ExtraPackagePriceType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}
